import React, { useState } from 'react';
import { ChevronDown as ChevronDownIcon, ChevronUp as ChevronUpIcon } from 'lucide-react';
interface MessageTemplateSelectorProps {
  onSelectTemplate: (template: string) => void;
}
export const MessageTemplateSelector: React.FC<MessageTemplateSelectorProps> = ({
  onSelectTemplate
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const templates = [{
    id: 1,
    name: 'Product Introduction',
    description: 'Introduce your product/service based on their engagement',
    template: 'Hi [Name],\n\nI noticed you recently engaged with content about [Topic]. I thought you might be interested in learning how [Your Company] helps businesses with [Value Proposition].\n\nWould you be open to a brief conversation about how we could potentially help [Their Company]?\n\nBest regards,\n[Your Name]'
  }, {
    id: 2,
    name: 'Content Follow-up',
    description: 'Share relevant content based on their interests',
    template: "Hi [Name],\n\nYour comment on [Post Topic] caught my attention. Based on your interest in this area, I thought you might find this resource valuable: [Resource Title].\n\nI'd love to hear your thoughts on it, and I'm happy to share more insights if you're interested.\n\nBest,\n[Your Name]"
  }, {
    id: 3,
    name: 'Event Invitation',
    description: 'Invite them to an upcoming webinar or event',
    template: "Hi [Name],\n\nBased on your interest in [Topic], I wanted to personally invite you to our upcoming [Event Name] on [Date].\n\nWe'll be discussing [Event Topics], and I think you'd find it particularly valuable given your role at [Their Company].\n\nWould you like me to send you the registration details?\n\nBest regards,\n[Your Name]"
  }, {
    id: 4,
    name: 'Request for Feedback',
    description: 'Ask for their expert opinion on a topic',
    template: "Hi [Name],\n\nI've been following your insights on [Topic] and really value your perspective. We're currently working on [Project/Feature], and I'd love to get your thoughts on our approach.\n\nWould you be open to a quick 15-minute call next week to share your feedback? Your expertise would be incredibly helpful.\n\nBest,\n[Your Name]"
  }, {
    id: 5,
    name: 'Mutual Connection',
    description: 'Reference a mutual connection or shared interest',
    template: "Hi [Name],\n\nI noticed we're both connected with [Mutual Connection], and I saw your comment about [Topic] on LinkedIn. Your perspective resonated with me, especially your point about [Specific Detail].\n\nI'd love to connect and potentially explore how [Your Company] and [Their Company] might collaborate on [Potential Area].\n\nBest regards,\n[Your Name]"
  }];
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4" data-id="element-539">
      <h3 className="text-md font-medium text-gray-700 mb-2" data-id="element-540">
        Message Templates
      </h3>
      <p className="text-sm text-gray-500 mb-4" data-id="element-541">
        Choose a template as a starting point for your message
      </p>
      <div className="space-y-3" data-id="element-542">
        {templates.map(template => <div key={template.id} className="border border-gray-200 rounded-lg hover:border-gray-300 cursor-pointer" data-id="element-543">
            <div className="flex justify-between items-center p-3" onClick={() => onSelectTemplate(template.template)} data-id="element-544">
              <div data-id="element-545">
                <h4 className="font-medium text-gray-800" data-id="element-546">{template.name}</h4>
                <p className="text-xs text-gray-500" data-id="element-547">{template.description}</p>
              </div>
              <button onClick={e => {
            e.stopPropagation();
            onSelectTemplate(template.template);
          }} className="px-3 py-1 text-xs font-medium text-white bg-[#f9b30f] rounded hover:bg-[#e0a40e]" data-id="element-548">
                Use
              </button>
            </div>
          </div>)}
      </div>
    </div>;
};